import React, { useMemo, useState } from "react";

export default function ConnectAmazonButton({ className = "" }) {
  const [err, setErr] = useState("");

  // Read query params once
  const { spid, corr } = useMemo(() => {
    try {
      const p = new URLSearchParams(window.location.search);
      return {
        spid: p.get("spid") || "",
        corr: p.get("corr") || "",
      };
    } catch (e) {
      setErr("Invalid URL");
      return { spid: "", corr: "" };
    }
  }, []);

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied!");
    } catch {
      setErr("Copy failed. Please copy manually.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 600 }}>
        <div
          className={className}
          style={{
            width: "100%",
            padding: 24,
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
            background: "#fff",
          }}
        >
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
            Token exchange succeed🎉
          </h1>

          <p style={{ fontSize: 14, color: "#555", marginTop: 12 }}>
            Code exchange completed. You may now close this window or continue.
          </p>

          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: "#666" }}>YOUR SPID</label>
            <div
              style={{
                marginTop: 6,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <code
                style={{
                  padding: "8px 10px",
                  background: "#f5f5f5",
                  borderRadius: 6,
                  fontSize: 14,
                  wordBreak: "break-all",
                  flex: 1,
                }}
              >
                {spid || "(missing)"}
              </code>
              <button
                onClick={() => copy(spid)}
                disabled={!spid}
                style={{
                  padding: "8px 10px",
                  borderRadius: 6,
                  border: "1px solid #ddd",
                  background: spid ? "#fafafa" : "#f3f4f6",
                  cursor: spid ? "pointer" : "not-allowed",
                }}
              >
                Copy
              </button>
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: "#666" }}>REF (corr)</label>
            <div
              style={{
                marginTop: 6,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <code
                style={{
                  padding: "8px 10px",
                  background: "#f5f5f5",
                  borderRadius: 6,
                  fontSize: 14,
                  wordBreak: "break-all",
                  flex: 1,
                }}
              >
                {corr || "(missing)"}
              </code>
              <button
                onClick={() => copy(corr)}
                disabled={!corr}
                style={{
                  padding: "8px 10px",
                  borderRadius: 6,
                  border: "1px solid #ddd",
                  background: corr ? "#fafafa" : "#f3f4f6",
                  cursor: corr ? "pointer" : "not-allowed",
                }}
              >
                Copy
              </button>
            </div>
          </div>

          <p style={{ fontSize: 15, color: "#888", marginTop: 16 }}>
            Note: Refresh token is stored securely on the server and never sent
            via URL.
          </p>

          {err && (
            <div
              role="alert"
              style={{
                color: "crimson",
                marginTop: 12,
                background: "#fff1f2",
                border: "1px solid #fecdd3",
                padding: 10,
                borderRadius: 8,
              }}
            >
              {err}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
